/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Match_Reason_Title_AddressInputs */

const cs_import_match_reason_title_address = /** @type {(inputs: Import_Match_Reason_Title_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda název + adresa (před commitem ověřte)`)
};

const en_import_match_reason_title_address = /** @type {(inputs: Import_Match_Reason_Title_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title + address match (confirm before commit)`)
};

/**
* | output |
* | --- |
* | "Title + address match (confirm before commit)" |
*
* @param {Import_Match_Reason_Title_AddressInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_match_reason_title_address = /** @type {((inputs?: Import_Match_Reason_Title_AddressInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Match_Reason_Title_AddressInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_match_reason_title_address(inputs)
	return cs_import_match_reason_title_address(inputs)
});